"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1997],{

/***/ 79926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CarouselGallary; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/nuka-carousel/es/index.js + 13 modules
var es = __webpack_require__(46499);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/carousel-gallary/decorators/bottom-center-points.scss.js


var StyledBottomCenterPoints = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "egoyoe40"
})(".bottom-center-point-button{color:", colors/* default.black */.Z.black, ";&:focus{color:", colors/* default.brand-blue */.Z["brand-blue"], ";}}");

;// CONCATENATED MODULE: ./components/core/carousel-gallary/decorators/bottom-center-points.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var BottomCenterPoints = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BottomCenterPoints, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BottomCenterPoints);
    function BottomCenterPoints(props) {
        (0,_class_call_check/* default */.Z)(this, BottomCenterPoints);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onDotClick", function(index) {
            var _props = _this.props, goToSlide = _props.goToSlide, bottomCenterExtraProps = _props.bottomCenterExtraProps;
            var onButtonClick = bottomCenterExtraProps.onButtonClick;
            if ((0,utils_service.isFunction)(onButtonClick)) {
                onButtonClick(index);
            }
            goToSlide(index);
        });
        _this.getIndexes = _this.getIndexes.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.getListStyles = _this.getListStyles.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.getListItemStyles = _this.getListItemStyles.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.getButtonStyles = _this.getButtonStyles.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(BottomCenterPoints, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var self = this;
                var _props = this.props, slideCount = _props.slideCount, slidesToScroll = _props.slidesToScroll, currentSlide = _props.currentSlide;
                var indexes = this.getIndexes(slideCount, slidesToScroll);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomCenterPoints, {
                    style: this.getListStyles(),
                    children: indexes.map(function(index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            style: self.getListItemStyles(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                tabIndex: 0,
                                className: "bottom-center-point-button",
                                style: self.getButtonStyles(currentSlide === index),
                                onClick: function() {
                                    return _this.onDotClick(index);
                                },
                                onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                                children: "•"
                            })
                        }, index);
                    })
                });
            }
        },
        {
            key: "getIndexes",
            value: function getIndexes(count, inc) {
                var arr = [];
                for(var i = 0; i < count; i += inc){
                    arr.push(i);
                }
                return arr;
            }
        },
        {
            key: "getListStyles",
            value: function getListStyles() {
                return {
                    position: "relative",
                    margin: 0,
                    top: -10,
                    padding: 0,
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center"
                };
            }
        },
        {
            key: "getListItemStyles",
            value: function getListItemStyles() {
                return {
                    listStyleType: "none",
                    display: "inline-block"
                };
            }
        },
        {
            key: "getButtonStyles",
            value: function getButtonStyles(active) {
                return {
                    border: 0,
                    background: "transparent",
                    cursor: "pointer",
                    padding: 10,
                    outline: 0,
                    fontSize: 24,
                    opacity: active ? 1 : 0.5
                };
            }
        }
    ]);
    return BottomCenterPoints;
}(react.PureComponent);

BottomCenterPoints.defaultProps = {
    bottomCenterExtraProps: {}
};

;// CONCATENATED MODULE: ./components/core/carousel-gallary/carousel-gallary.js





function carousel_gallary_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_gallary_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var getSettings = function(param) {
    var bottomCenterExtraProps = param.bottomCenterExtraProps;
    return {
        renderBottomCenterControls: function(param) {
            var currentSlide = param.currentSlide, slideCount = param.slideCount, goToSlide = param.goToSlide, slidesToScroll = param.slidesToScroll;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCenterPoints, {
                currentSlide: currentSlide,
                slideCount: slideCount,
                goToSlide: goToSlide,
                slidesToScroll: slidesToScroll,
                bottomCenterExtraProps: bottomCenterExtraProps
            });
        }
    };
};
var CarouselGallary = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CarouselGallary, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CarouselGallary);
    function CarouselGallary(props) {
        (0,_class_call_check/* default */.Z)(this, CarouselGallary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            carouselSlideIndex: props.slideIndex
        };
        _this.afterCarouselSlide = _this.afterCarouselSlide.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(CarouselGallary, [
        {
            key: "afterCarouselSlide",
            value: function afterCarouselSlide(slideIndex) {
                var afterSlide = this.props.afterSlide;
                this.setState({
                    carouselSlideIndex: slideIndex
                }, function() {
                    if ((0,utils_service.isFunction)(afterSlide)) {
                        afterSlide(slideIndex);
                    }
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, bottomCenterExtraProps = _props.bottomCenterExtraProps;
                var carouselSlideIndex = this.state.carouselSlideIndex;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, _object_spread_props(_object_spread({}, getSettings({
                    bottomCenterExtraProps: bottomCenterExtraProps
                }), this.props), {
                    afterSlide: this.afterCarouselSlide,
                    children: react.Children.map(children, function(child, index) {
                        return /*#__PURE__*/ (0,react.cloneElement)(child, {
                            isCurrentSlide: carouselSlideIndex == index
                        });
                    })
                }));
            }
        }
    ]);
    return CarouselGallary;
}(react.PureComponent);

CarouselGallary.defaultProps = {
    bottomCenterExtraProps: {}
};


/***/ }),

/***/ 51997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CarouselTestimonialsComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/carousel-gallary/carousel-gallary.js + 2 modules
var carousel_gallary = __webpack_require__(79926);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/testimonial/testimonial-component.scss.js



var StyledTestimonialComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e143b79o0"
})("background-color:", colors/* default.white */.Z.white, ";display:flex;flex-direction:column;opacity:0.5;&.active{opacity:1;}.testimonial-image-container{width:98%;max-width:290px;height:100px;border:2px solid;border-color:", colors/* default.wolf */.Z.wolf, ";border-radius:8px;background-color:", colors/* default.white */.Z.white, ";position:relative;top:42px;display:flex;margin:0 auto;justify-content:center;align-items:center;.testimonial-image{padding:4px;width:auto;height:auto;max-width:250px;max-height:90px;}@media (max-width:", vp_sizes/* SMALL_MOBILE_QUERY_MAX_WIDTH */.cb, "){.testimonial-image{transform:scale(0.7);}}}.testimonial-text-container{background-color:", colors/* default.riverstone */.Z.riverstone, ";display:flex;flex-direction:column;align-items:center;justify-content:center;height:280px;border-radius:8px;.testimonial-text{color:", colors/* default.mud */.Z.mud, ";padding:0 10%;text-align:center;margin-top:36px;font-size:1.375rem;}.testimonial-person-container{margin-top:32px;margin-bottom:24px;font-size:1.125rem;text-align:center;.testimonial-person-name{font-weight:bold;}.separator{margin:0 4px;}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.testimonial-text,.testimonial-person-container{font-size:1rem;}.testimonial-text{margin-top:60px;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.testimonial-text,.testimonial-person-container{font-size:0.875rem;}.testimonial-text{margin-top:60px;}}@media (max-width:", vp_sizes/* SMALL_MOBILE_QUERY_MAX_WIDTH */.cb, "){.testimonial-text,.testimonial-person-container{font-size:0.8125rem;}.testimonial-text{margin-top:60px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/testimonial/testimonial-component.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var TestimonialComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TestimonialComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TestimonialComponent);
    function TestimonialComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, TestimonialComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderImage", function() {
            var testimonial = _this.props.testimonial;
            var image = testimonial.image;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "testimonial-image-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread_props(_object_spread({}, image), {
                    className: "testimonial-image"
                }))
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderMainText", function() {
            var _props = _this.props, testimonial = _props.testimonial, translate = _props.translate;
            var testimonialText = testimonial.testimonialText;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "testimonial-text",
                    dangerouslySetInnerHTML: {
                        __html: translate(testimonialText)
                    }
                })
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderPerson", function() {
            var _props = _this.props, testimonial = _props.testimonial, translate = _props.translate;
            var personName = testimonial.personName, personRole = testimonial.personRole;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "testimonial-person-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "testimonial-person-name",
                        children: translate(personName)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "separator",
                        children: translate("pricingPage.testimonials.separator")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "testimonial-person-title",
                        children: translate(personRole)
                    })
                ]
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(TestimonialComponent, [
        {
            key: "render",
            value: function render() {
                var isCurrentSlide = this.props.isCurrentSlide;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTestimonialComponent, {
                    className: classnames_default()("testimonial-component", {
                        active: isCurrentSlide
                    }),
                    children: [
                        this.renderImage(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "testimonial-text-container",
                            children: [
                                this.renderMainText(),
                                this.renderPerson()
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return TestimonialComponent;
}(react.PureComponent);
/* harmony default export */ var testimonial_component = ((0,generic_config_context/* withGenericConfig */.P)(TestimonialComponent));

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/carousel-testimonials-component.scss.js


var StyledCarouselTestimonialsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejstzsx0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:24px 0 60px;.slider-list{height:460px !important;}");

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/default-props.js
/* harmony default export */ var default_props = ({
    testimonials: [
        {
            name: "thoughtworks",
            testimonialText: "pricingPage.testimonials.defaults.thoughtworks.testimonialText",
            personName: "pricingPage.testimonials.defaults.thoughtworks.personName",
            personRole: "pricingPage.testimonials.defaults.thoughtworks.personTitle",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1607704782/remote_mondaycom_static/img/segment-layout-default-images/customer-testimonials/thoughtworks.png",
                alt: "Thoughtworks logo"
            }
        },
        {
            name: "telefonica",
            testimonialText: "pricingPage.testimonials.defaults.telefonica.testimonialText",
            personName: "pricingPage.testimonials.defaults.telefonica.personName",
            personRole: "pricingPage.testimonials.defaults.telefonica.personTitle",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1607704782/remote_mondaycom_static/img/segment-layout-default-images/customer-testimonials/telefonica.png",
                alt: "Telefonica logo"
            }
        },
        {
            name: "genpact",
            testimonialText: "pricingPage.testimonials.defaults.genpact.testimonialText",
            personName: "pricingPage.testimonials.defaults.genpact.personName",
            personRole: "pricingPage.testimonials.defaults.genpact.personTitle",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1607704782/remote_mondaycom_static/img/segment-layout-default-images/customer-testimonials/genpact.png",
                alt: "Genpact logo"
            }
        }
    ],
    autoplay: {
        interval: "10000",
        shouldAutoPlay: true,
        pauseOnHover: true,
        wrapAround: true
    },
    testimonialChangeEventData: {},
    carouselWidth: "100vw"
});

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/carousel-testimonials-component.js






function carousel_testimonials_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_testimonials_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_testimonials_component_define_property(target, key, source[key]);
        });
    }
    return target;
}








var DEFAULT_AUTOPLAY_INTERVAL = 10000; // 10 seconds
var CarouselTestimonialsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CarouselTestimonialsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CarouselTestimonialsComponent);
    function CarouselTestimonialsComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, CarouselTestimonialsComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        carousel_testimonials_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onManualTestimonialChange", function(index) {
            var _props = _this.props, testimonials = _props.testimonials, testimonialChangeEventData = _props.testimonialChangeEventData;
            var selected = testimonials[index];
            var name = selected.name;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CUSTOMER_TESTIMONIAL_CHANGED_MANUALLY, carousel_testimonials_component_object_spread({
                info1: index,
                info2: name
            }, testimonialChangeEventData));
        });
        carousel_testimonials_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderTestimonials", function() {
            var testimonials = _this.props.testimonials;
            return testimonials.map(function(testimonial) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonial_component, {
                    testimonial: testimonial
                }, testimonial.name);
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(CarouselTestimonialsComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, autoplay = _props.autoplay, carouselWidth = _props.carouselWidth;
                var shouldAutoPlay = autoplay.shouldAutoPlay, interval = autoplay.interval, pauseOnHover = autoplay.pauseOnHover, wrapAround = autoplay.wrapAround;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarouselTestimonialsComponent, {
                    className: "carousel-testimonials-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_gallary/* default */.Z, {
                        className: "carousel-item",
                        autoplay: shouldAutoPlay,
                        autoplayInterval: Number(interval) || DEFAULT_AUTOPLAY_INTERVAL,
                        pauseOnHover: pauseOnHover,
                        wrapAround: wrapAround,
                        edgeEasing: "easeBack",
                        slidesToShow: 1,
                        slideIndex: 1,
                        cellAlign: "center",
                        cellSpacing: 16,
                        width: carouselWidth,
                        slideWidth: 0.7,
                        renderCenterLeftControls: function() {},
                        renderCenterRightControls: function() {},
                        heightMode: "max",
                        bottomCenterExtraProps: {
                            onButtonClick: this.onManualTestimonialChange
                        },
                        children: this.renderTestimonials()
                    })
                });
            }
        }
    ]);
    return CarouselTestimonialsComponent;
}(react.PureComponent);

CarouselTestimonialsComponent.defaultProps = default_props;


/***/ })

}]);